import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const technoliesApiUrl = `${baseApiUrl}/api/Technologies`;

export async function getTechnologies(name = "") {
  return await httpRequest(fetchTechnologies.bind(this, name));
}

async function fetchTechnologies(name) {
  let config = getHttpHeaders();
  return await axios.get(`${technoliesApiUrl}?Name=${name}`, config);
}

export async function updateTechnology(company) {
  return await httpRequest(putTechnology.bind(this, company));
}

async function putTechnology(company) {
  let config = getHttpHeaders();
  return await axios.put(`${technoliesApiUrl}`, company, config);
}

export async function addTechnology(newcompany) {
  return await httpRequest(postTechnology.bind(this, newcompany));
}

async function postTechnology(newcompany) {
  let config = getHttpHeaders();
  return await axios.post(`${technoliesApiUrl}`, newcompany, config);
}

export async function deleteTechnology(id) {
  return await httpRequest(fetchDeleteTechnology.bind(this, id));
}

async function fetchDeleteTechnology(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${technoliesApiUrl}/${id}`, config);
}
